import { Grid } from '@mui/material';
import { Cropper } from 'shell/components/shared/cropper';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { DocumentMarriageFormVM } from 'civil-status/view-models/document-birth-form';
// import CivilStatusList from 'shell/components/shared/civil-status-list';
import { PageMode } from 'civil-status/view-models/page-mode';
import UploadFileForm from '../shared/upload-file';
import AnnotationForm from '../shared/annotation';
import { StickyDiv } from 'shell/components/shared/sticky-div';
import DocumentMarriageFormShared from '../shared/marriage-form';

interface DocumentMarriageFormProps {
  values?: DocumentMarriageFormVM;
  errors?: FormikErrors<DocumentMarriageFormVM>;
  touched?: FormikTouched<DocumentMarriageFormVM>;
  onChange: (
    key: keyof DocumentMarriageFormVM,
    value: DocumentMarriageFormVM[keyof DocumentMarriageFormVM]
  ) => void;
  onChanges: (value: DocumentMarriageFormVM) => void;
  mode: PageMode;
  type: string;
  setMode: (mode: PageMode) => void;
}

const DocumentMarriageComponent = ({
  values,
  touched,
  errors,
  mode,
  onChange,
  onChanges,
  type,
  setMode,
}: DocumentMarriageFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        {/* <ButtonsForm
          mode={mode}
          onAnnotationInternationalMode={onAnnotationInternationalMode}
          onAnnotationNationalMode={onAnnotationNationalMode}
          onDetailMode={onDetailMode}
          onEditMode={onEditMode}
          onPrintMode={onPrintMode}
          onSubstitutionMode={onSubstitutionMode}
          onAnnotationInternationalDeleteAll={handleDeleteAllInternational}
          onAnnotationNationalDeleteAll={handleDeleteAllNational}
          url="/stato-civile/matrimonio/ricerca"
        /> */}
        {/* <DescriptionForm values={values} /> */}
        <UploadFileForm values={values} onChange={onChange} mode={mode} />
        {mode === PageMode.Edit || mode === PageMode.Detail ? (
          <DocumentMarriageFormShared
            onChange={onChange}
            onChanges={onChanges}
            values={values}
            errors={errors}
            mode={mode}
            touched={touched}
          />
        ) : undefined}
        <AnnotationForm
          values={values}
          onChange={onChange}
          mode={mode}
          type={type}
          setMode={setMode}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <StickyDiv>
          <Cropper
            images={values?.uploadFile?.raw || []}
            disabled={!values?.uploadFile?.raw?.length}
          />
        </StickyDiv>
      </Grid>
    </Grid>
  );
};

DocumentMarriageComponent.displayName = 'Document Marriage form component';

const DocumentMarriageForm = memo(DocumentMarriageComponent);

export default DocumentMarriageForm;
